<i18n src="./resources/locales.json"></i18n>

<template>
  <EcsAgentWallboardInformation />
</template>

<script>
import EcsAgentWallboardInformation from '@/components/ecs-wallboard-information/EcsWallboardInformation';

export default {
  name: 'EcsWallboardPage',

  components: { EcsAgentWallboardInformation }
};
</script>

<style scoped></style>
